import PartKayu from './PartKayu';

export default PartKayu;
